import { useEffect, useState } from 'react';
import { FaWindows } from 'react-icons/fa';
import hiZipLogo from '../assets/hizip-logo.png';

const DOWNLOAD_LINK = '/HiZip Setup 1.0.1.exe';

const detectIsWindows = () => {
  if (typeof navigator === 'undefined') return false;

  if (navigator.userAgentData?.platform) return navigator.userAgentData.platform.toLowerCase().includes('windows');

  const ua = (navigator.userAgent || navigator.platform || '').toLowerCase();

  return ua.includes('windows') || ua.includes('win32') || ua.includes('win64');
};

const features = [
  {
    title: 'Молниеносная скорость',
    description: 'Архивация и распаковка занимают секунды даже для больших папок.'
  },
  {
    title: 'Понятный интерфейс',
    description: 'Разобраться можно за минуту — без лишних меню и настроек.'
  },
  {
    title: 'Регулярные обновления',
    description: 'Приложение развивается по фидбэку пользователей, а не лежит без изменений.'
  }
];

const HiZip = () => {
  const [isWindows, setIsWindows] = useState(null);

  useEffect(() => {
    setIsWindows(detectIsWindows());
  }, []);

  return (
    <section className='py-32 relative overflow-hidden'>
      <div className='before:content-[""] before:absolute before:-top-80 before:-right-80 before:w-[800px] before:h-[800px] before:bg-gradient-radial before:from-cyan-400/10 before:to-transparent before:z-0 before:animate-pulse'></div>
      <div className='container mx-auto px-8 max-w-5xl relative z-10'>
        <div className='text-center mb-16 animate'>
          <div className='w-32 h-32 mx-auto mb-6 flex items-center justify-center'>
            <img src={hiZipLogo} alt='HiZip' className='w-full h-full object-contain' />
          </div>
          <h1 className='section-title'>HiZip</h1>
          <p className='text-xl text-gray-600 dark:text-gray-400 max-w-2xl mx-auto mb-4'>
            Упаковывает файлы — распаковывает нервы. Работает мгновенно, выглядит как будущее.
          </p>
          <div className='inline-flex items-center gap-2 glass-card px-4 py-2 rounded-full text-sm font-semibold text-gray-700 dark:text-gray-200'>
            <FaWindows className='text-sky-500 dark:text-cyan-300' />
            Пока доступно только для Windows
          </div>
        </div>

        <div className='grid grid-cols-1 md:grid-cols-3 gap-8 mb-16'>
          {features.map((feature, index) => (
            <div key={index} className='glass-card rounded-2xl p-6 animate'>
              <h3 className='text-lg font-montserrat font-bold mb-2 text-gray-900 dark:text-white'>
                {feature.title}
              </h3>
              <p className='text-gray-600 dark:text-gray-400'>{feature.description}</p>
            </div>
          ))}
        </div>

        <div className='text-center animate'>
          {isWindows ? (
            <a
              href={DOWNLOAD_LINK}
              className='inline-flex items-center gap-3 bg-gradient-to-br from-cyan-400 to-sky-500 text-[#0b1e3d] font-bold py-4 px-10 rounded-xl shadow-lg hover:shadow-xl hover:-translate-y-1 hover:from-sky-500 hover:to-cyan-400 transition-all duration-300 text-lg'
            >
              <FaWindows />
              Скачать для Windows
            </a>
          ) : isWindows === false ? (
            <div className='inline-flex flex-col items-center gap-2'>
              <button
                disabled
                className='inline-flex items-center gap-3 bg-gray-300 dark:bg-gray-700 text-gray-500 dark:text-gray-400 font-bold py-4 px-10 rounded-xl cursor-not-allowed text-lg'
              >
                <FaWindows />
                Недоступно для вашей системы
              </button>
              <p className='text-sm text-gray-500 dark:text-gray-400'>
                HiZip пока работает только на Windows. Версии для macOS и Android в разработке.
              </p>
            </div>
          ) : null}
        </div>
      </div>
    </section>
  );
};

export default HiZip;
